module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title12"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Thanks to Dan Cuoco and the IBRO members for their help and contributions.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('br'), _vm._v(" To all the memorable boxers (and their families) that are not in this book, the authors regret that due to a lack of photos not all top Chicago fighters could be included. Thank you for all the thrills you have provided Chicago fans over the years.")])])])]), _c('a', {
    attrs: {
      "id": "title12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32de7796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439614785_ack01.vue
// module id = 75
// module chunks = 0